<template>
        <v-date-input
            :data-cy="`${dataCyPrefix}-date`"
            ref="dateField"
            v-model="modelValue.date"
            :label="$t('formFields.date')"
            variant="outlined"
            multiple="range"
            prepend-icon=""
            @update:modelValue="updateDetails('date', $event)"
            :rules="[requiredRule]"
        ></v-date-input>
</template>

<script>
export default {
    props: {
        modelValue: Object,
        dataCyPrefix: String,
    },
    emits: ["update:modelValue"],
    data() {
        return {
            requiredRule: (value) => !!value || this.$t("validation.required"),
        };
    },
    methods: {
        async validateFields() {
            await this.$nextTick();

            let isValid = true;

            if (
                !this.modelValue.date ||
                !Array.isArray(this.modelValue.date) ||
                this.modelValue.date.length === 0
            ) {
                isValid = false;
            }

            return isValid;
        },
        resetValidation() {
            this.$nextTick(() => {
                if (this.$refs.dateField?.resetValidation) {
                    this.$refs.dateField.resetValidation();
                }
            });
        },
        updateDetails(field, value) {
            if (field === "date" && Array.isArray(value) && value.length > 0) {
                const ymd = (v) => {
                    const d = v instanceof Date ? v : new Date(v);
                    const y = d.getFullYear();
                    const m = String(d.getMonth() + 1).padStart(2, "0");
                    const day = String(d.getDate()).padStart(2, "0");
                    return `${y}-${m}-${day}`;
                };

                const startDate = value[0];
                const endDate = value[value.length - 1];

                this.$emit("update:modelValue", {
                    ...this.modelValue,
                    dateStart: ymd(startDate),
                    dateEnd: ymd(endDate),
                    date: value,
                });
            } else {
                this.$emit("update:modelValue", {
                    ...this.modelValue,
                    [field]: value,
                });
            }
        },
    },
};
</script>
